module.exports = __webpack_public_path__ + "img/League.318c7796.png";